import React, { useEffect, useState } from 'react';
import { IEditBuildingProps } from './IEditBuildingProps';
import { useNavigate } from 'react-router-dom';
import Spinner from '../Spinner';
import ConfirmAlert from '../confirmAlert';
import ErrorAlert from '../ErrorAlert';
import SuccessAlert from '../SuccessAlert';
import WarningAlert from '../WarningAlert';
import { ApiHandler } from '../../services/apiHandler';
import LabelledInput from '../LabelledInput';
import Dropzone from 'react-dropzone';
import PrimaryButton from '../PrimaryButton';
import { CloseOutlined, DeleteTwoTone, FileImageOutlined } from '@ant-design/icons';
import LabelledInputNew from '../LabelledInputNew';
import LevelSelectorGeoJson from '../GeoJsonLevel';
import SecondaryButton from '../SecondaryButton';
import { PenIcon } from '../../custom_icons/PenTool';
import { VenueDrawPlot } from '../VenueDrawPlot/VenueDrawPlot';
import Dragger from 'antd/es/upload/Dragger';
import { Upload, UploadProps } from 'antd';
import ImageResizer from 'react-image-file-resizer';
import { remove } from 'jszip';
import { set } from 'rsuite/esm/utils/dateUtils';

export const EditBuilding: React.FC<IEditBuildingProps> = (props) => {
  let navigate = useNavigate();
  const [confirmAlert, setConfirmAlert] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({
    message: '',
    alert: false,
  });
  const [warning, setWarning] = useState({
    message: '',
    alert: false,
  });
  const [success, setSuccess] = useState({
    message: '',
    alert: false,
  });
  const [building, setBuilding] = useState<any>();
  const [isDrawActive, setIsDrawActive] = useState(false);
  const [boundaryConfirmed, setBoundaryConfirmed] = useState(false);
  const [imageUploaded, setImageUploaded] = useState(false);
  const [assetBuildingConfimrationModal, setAssetBuildingConfimrationModal] = useState({ alert: false, message: '' });
  const [removeBuildingAssets, setRemoveBuildingAssets] = useState(false);

  useEffect(() => {
    getBuilding();
  }, [props.buildingId]);

  const getBuilding = () => {
    setLoading(true);
    ApiHandler({ apiName: 'getBuilding', body: {}, params: { building_id: props.buildingId } })
      .then((res: any) => {
        setLoading(false);
        setBuilding(res.data);
      })
      .catch((error: any) => {
        setLoading(false);
        if (error.doLogout === true) {
          setError({ message: 'Session Timed Out', alert: true });
          setTimeout(() => navigate('/login', { replace: true }), 2000);
        } else {
          setError({ message: error.data.message, alert: true });
        }
      });
  };

  const propsDragger: UploadProps = {
    name: 'file',
    multiple: false,
    onDrop(e) {
      console.log('Dropped files', e.dataTransfer.files);
    },
    accept: 'image/png, image/jpeg',

    beforeUpload: (file) => {
      const isImage = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isImage) {
        setWarning({ message: 'You can only upload JPG/PNG file!', alert: true });
        return Upload.LIST_IGNORE;
      }

      const isLt4M = file.size / 1024 / 1024 < 4;
      if (!isLt4M) {
        setWarning({ message: 'Image must be smaller than 4MB!', alert: true });
        return Upload.LIST_IGNORE;
      }

      console.log('Uploading and resizing image');
      ImageResizer.imageFileResizer(
        file,
        800,
        800,
        'JPEG',
        100,
        0,
        (uri: any) => {
          setImageUploaded(true);
          setBuilding((prevValues: any) => {
            return { ...prevValues, ['image']: uri };
          });
          // uploadImageApi('', file, uri);
        },
        'base64'
      );

      return false;
    },
  };

  const handleInputChange = (e: any) => {
    setBuilding((prevValues: any) => {
      return { ...prevValues, [e.target.name]: e.target.value };
    });
  };

  const validateRequest = () => {
    if (building.name.trim() === '' || !building.name) {
      setWarning({ message: 'Building name is required', alert: true });
      return false;
    } else if (/[^a-zA-Z\s]/.test(building.name)) {
      setWarning({ message: 'Building name cannot contain numbers or special characters', alert: true });
      return false;
    } else if (Number(building?.total_floors) < 0) {
      setWarning({ message: 'Please enter a valid number of floors.', alert: true });
      return false;
    } else if (Number(building?.floors_in_use) < 0) {
      setWarning({ message: 'Please enter a valid number of floors in use.', alert: true });
      return false;
    } else if (Number(building?.floors_in_use) > Number(building?.total_floors)) {
      setWarning({ message: 'Floors in use cannot be greater than total floors.', alert: true });
      return false;
    } else if (Number(building.height) < 0) {
      setWarning({ message: 'Please enter a valid building height.', alert: true });
      return false;
    } else if (Number(building.elevation) < 0) {
      setWarning({ message: 'Please enter a valid elevation.', alert: true });
      return false;
    }
    return true;
  };

  const setBoundaryPolygonToCreatBuilding = () => {
    // set boundary plot from google.maps.LatLng to {lat: number, lng: number}
    let boundary = props.boundaryPolygon?.map((point) => {
      return {
        lat: parseFloat(point.lat().toFixed(6)),
        lng: parseFloat(point.lng().toFixed(6)),
      };
    });
    // push first vertex as last vertex to make it a closed polygon
    boundary?.push(boundary[0]);
    return boundary;
  };

  const updateBuilding = () => {
    if (!validateRequest()) return;
    // if (!boundaryConfirmed) {
    //   setWarning({
    //     message: 'Please confirm the building boundary before creating the building.',
    //     alert: true,
    //   });
    //   return;
    // }
    setLoading(true);
    let formData = new FormData();
    let boundary = setBoundaryPolygonToCreatBuilding();
    console.log(building.polygon_points, 'Boundary to be sent:', boundary);
    formData.append('name', building.name);
    formData.append('description', building.description);
    formData.append('address', building.address);
    formData.append('total_floors', building.total_floors.toString());
    if (boundary && boundary?.length > 0 && typeof boundary[0] !== 'undefined') formData.append('boundary_plot', JSON.stringify(boundary));
    else formData.append('boundary_plot', JSON.stringify(building.polygon_points));
    if (typeof building.image === 'object') {
      formData.append('image', building.image);
    }

    ApiHandler({
      apiName: 'updateBuilding',
      body: formData,
      params: { building_id: props.buildingId },
    })
      .then((res: any) => {
        setLoading(false);
        if (removeBuildingAssets) {
          removeAssetsBuilding();
        }
        props.setVenueBoundaryPath([]);
        setSuccess({ message: 'Building Updated Successfully', alert: true });
        setTimeout(() => {
          props.navigateTo('buildingDetails');
        }, 1000);
      })
      .catch((error: any) => {
        setLoading(false);
        if (error.doLogout === true) {
          setError({ message: 'Session Timed Out', alert: true });
          setTimeout(() => navigate('/login', { replace: true }), 2000);
        } else {
          setError({ message: error.data.message, alert: true });
        }
      });
  };
  const drawBoundary = () => {
    setIsDrawActive(true);
    if (!boundaryConfirmed) props.setVenueBoundaryPath(building.polygon_points.map((point: any) => new google.maps.LatLng(point.lat, point.lng)));
    props.setBoundaryDrawMode('draw');
  };

  const removeAssetsBuilding = () => {
    setLoading(true);
    const requestBody: any = { asset_ids: [] };
    props.assets?.forEach((asset: any) => {
      requestBody.asset_ids.push(asset.id);
    });
    ApiHandler({ apiName: 'removeAssetFromBuilding', body: requestBody, params: {} })
      .then((response: any) => {
        setLoading(false);
      })
      .catch((error: any) => {
        setLoading(false);
        if (error.doLogout === true) {
          setError({ message: 'Session Timed Out', alert: true });
          setTimeout(() => navigate('/login', { replace: true }), 2000);
        } else {
          setError({ message: error.data.message, alert: true });
        }
      });
  };
  const checkAssetsBuildingsInVenue = () => {
    console.log('Checking assets/buildings in venue…');

    const newBoundary =
      props.boundaryPolygon?.map((p) => ({
        lat: parseFloat(p.lat().toFixed(6)),
        lng: parseFloat(p.lng().toFixed(6)),
      })) || [];

    let deleteMessage = '';

    if (props.assets && props.assets.length > 0) {
      deleteMessage += `
      <span>Following assets are outside the venue:</span><br/><br/>
      <ul>
        ${props.assets.map((a) => `<li>${a.tracking_id}</li>`).join('')}
      </ul>
      <i>On confirming, these assets will <b>be dissociated from the Building</b>.</i>
      <br/><br/>
    `;
    }

    if (props.assets && props.assets.length === 0 && props.assets.length === 0) {
      console.log('No assets/buildings outside venue, proceeding to update venue');
      setBoundaryConfirmed(true);
      setIsDrawActive(false);
      props.setBoundaryDrawMode(null);
      return;
    }

    deleteMessage += `Do you want to proceed?`;

    setAssetBuildingConfimrationModal({
      alert: true,
      message: deleteMessage,
    });
  };
  const confirmBoundary = () => {
    // const inside = google.maps.geometry.poly.conta
    if (typeof props.boundaryPolygon == 'undefined' || props.boundaryPolygon.length === 0) {
      setBoundaryConfirmed(false);
      setWarning({
        message: "Boundary of the Building is not defined yet. Click on the 'Draw Boundaries' button to start.",
        alert: true,
      });
      return;
    }

    if (props.assets && props.assets.length > 0) {
      checkAssetsBuildingsInVenue();
    }

    setBoundaryConfirmed(true);
    setIsDrawActive(false);
    props.setBoundaryDrawMode(null);
  };
  const cancelBoundary = () => {
    setIsDrawActive(false);
    props.cancelBoundaryDraw();
  };

  return (
    <div className="h-100 row-wise overflow-auto">
      <div className="right row-wise ">
        {isDrawActive && <VenueDrawPlot setColor={() => {}} color={''} />}

        <div className="app-card app-card-size ">
          <div className="row-wise vertical-center px-4 py-2 space-between">
            <span className="app-card-action-heading fw-bold">Update Building</span>
            <div
              onClick={() => {
                props.navigateTo('buildingDetails');
              }}>
              <CloseOutlined className="fs-6 cursor-pointer" />
            </div>
          </div>
          <div className="border-bottom" />
          <div className="overflow-auto">
            <div className="border-bottom mx-4" />
            <div className="px-4 py-2">
              {imageUploaded ? (
                <div className="vertical-center center my-3 position-relative">
                  <DeleteTwoTone
                    className="position-absolute z-index-10"
                    onClick={() => {
                      const buildingTemp = building;
                      buildingTemp['image'] = undefined;
                      setBuilding(buildingTemp);
                      setImageUploaded(false);
                    }}
                  />
                  <img src={building.image} height={'auto'} width={350 - 48} />
                </div>
              ) : (
                <div className="drop-height">
                  <Dragger {...propsDragger}>
                    <p className="ant-upload-drag-icon">
                      <FileImageOutlined />
                    </p>
                    <p className="ant-upload-textupload-text">Click or drag file to this area to upload</p>
                    <p className="ant-upload-hint upload-text-sub">Pick a photo up to 4MB.</p>
                  </Dragger>
                </div>
              )}
              <div className="fw-semibold small text-muted mb-2 mt-2">Building Boundaries</div>
              {isDrawActive ? (
                <div className="row ">
                  <div className="col-6">
                    <SecondaryButton className="my-1 h-btn-lg" label={'Confirm Boundary'} clicked={confirmBoundary} disable={false} />
                  </div>
                  <div className="col-6">
                    <SecondaryButton className="my-1 h-btn-lg" label={'Cancel'} clicked={cancelBoundary} disable={false} type="delete" />
                  </div>
                </div>
              ) : (
                <div className="w-100">
                  <SecondaryButton
                    className="mb-2 mt-2"
                    label={'Edit boundaries'}
                    clicked={drawBoundary}
                    disable={false}
                    icon={<PenIcon style={{ color: '#1677FF' }} />}
                  />
                </div>
              )}

              <form className="col-wise h-100 pb-1 mb-1 pt-2">
                <LabelledInputNew
                  title="Name *"
                  name="name"
                  onChange={(e: any) => {
                    handleInputChange(e);
                  }}
                  value={building?.name}
                  placeholder="Enter name"
                  titleClassName="fw-semibold small text-muted"
                  textColorRequired={false}
                />
                <LabelledInputNew
                  title="Total Floors"
                  name="total_floors"
                  onChange={(e: any) => {
                    handleInputChange(e);
                  }}
                  type="number"
                  value={building?.total_floors}
                  placeholder="Enter total floors"
                  titleClassName="fw-semibold small text-muted"
                  textColorRequired={false}
                />
                <div className="mb-2">
                  <span className="d-block mb-2 fw-semibold small text-muted">Description</span>
                  <textarea
                    rows={5}
                    id="description"
                    className="w-100 textbox-box input-text h-auto p-2"
                    placeholder="Enter description"
                    name="description"
                    onChange={(e: any) => {
                      handleInputChange(e);
                    }}
                    value={building?.description}></textarea>
                </div>

                {/* Image Upload */}
                {/* <Dropzone
                  multiple={false}
                  onDrop={(acceptedFiles: any) => {
                    setBuilding((prevValues: any) => {
                      return { ...prevValues, image: acceptedFiles[0] };
                    });
                    console.log(acceptedFiles[0]);
                  }}
                  accept={{ 'image/jpg': ['.jpg'], 'image/jpeg': ['.jpeg'], 'image/png': ['.png'] }}>
                  {({ getRootProps, getInputProps }) => (
                    <section className="img-dropzone-set mb-2">
                      <div
                        {...getRootProps({
                          className: `${![undefined, null, ''].includes(building?.image) ? 'img-building-uploaded' : 'img-building'}`,
                        })}>
                        <input {...getInputProps()} />

                        {[undefined, null, ''].includes(building?.image) ? (
                          <div className="row-wise vertical-center ps-2 w-100 h-100">
                            <span className="material-icons-outlined">add_a_photo</span>
                            <span className="ps-2">Upload Building Image</span>
                          </div>
                        ) : (
                          <div className="row-wise vertical-center ps-2 w-100 h-100">
                            <span className="material-icons-outlined">photo_camera</span>
                            <span className="ps-2">{building?.image['name'] ?? 'Image Uploaded'}</span>
                          </div>
                        )}
                      </div>
                      <div></div>
                    </section>
                  )}
                </Dropzone> */}

                {/* <div className="mb-2">
                  <span className="d-block mb-2 fw-semibold small text-muted">Street Address</span>
                  <textarea
                    rows={5}
                    id="address"
                    className="w-100 textbox-box input-text h-auto p-2"
                    placeholder="Enter Street Address"
                    name="address"
                    onChange={(e: any) => {
                      handleInputChange(e);
                    }}
                    value={building?.address}></textarea>
                </div> */}

                {/* <LabelledInputNew
                  title="Street Address"
                  name="address"
                  onChange={(e: any) => {
                    handleInputChange(e);
                  }}
                  value={building?.address}
                  placeholder="Enter Street Address"
                  titleClassName="fw-semibold small text-muted"
                  textColorRequired={false}
                /> */}
                <span className="d-block mb-2 fw-semibold small text-muted">Street Address</span>

                <textarea
                  rows={2}
                  id="address"
                  className="w-100 textbox-box input-text h-auto p-2"
                  placeholder="Enter street address"
                  name="address"
                  onChange={(e: any) => {
                    handleInputChange(e);
                  }}
                  value={building?.address}></textarea>

                <div className="row gx-2 mt-1">
                  <div className="col-6">
                    <LabelledInputNew
                      title="City"
                      name="city"
                      onChange={(e: any) => {
                        handleInputChange(e);
                      }}
                      value={building?.city}
                      placeholder="Enter City"
                      titleClassName="fw-semibold small text-muted"
                      textColorRequired={false}
                    />
                  </div>
                  <div className="col-6">
                    <LabelledInputNew
                      title="State"
                      name="state"
                      onChange={(e: any) => {
                        handleInputChange(e);
                      }}
                      value={building?.state}
                      placeholder="Enter State"
                      titleClassName="fw-semibold small text-muted"
                      textColorRequired={false}
                    />
                  </div>
                </div>

                <div className="row gx-2">
                  <div className="col-6">
                    <LabelledInputNew
                      title="Country"
                      name="country"
                      onChange={(e: any) => {
                        handleInputChange(e);
                      }}
                      value={building?.country}
                      placeholder="Enter Country"
                      titleClassName="fw-semibold small text-muted"
                      textColorRequired={false}
                    />
                  </div>
                  <div className="col-6">
                    <LabelledInputNew
                      title="Zip Code"
                      name="zipcode"
                      onChange={(e: any) => {
                        handleInputChange(e);
                      }}
                      value={building?.zip_code}
                      placeholder="Enter ZIP"
                      titleClassName="fw-semibold small text-muted"
                      textColorRequired={false}
                    />
                  </div>
                </div>

                <div className="row g-2 mb-3 mt-2">
                  <div className="col-6">
                    <div className="rounded p-2" style={{ backgroundColor: '#e4f1f4' }}>
                      <span className="d-block mb-1 fw-semibold small text-muted">Latitude</span>
                      <span className="d-block fw-bold text-dark">{building?.location?.lat?.toFixed(6) || '0.000000'}</span>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="rounded p-2" style={{ backgroundColor: '#e4f1f4' }}>
                      <span className="d-block mb-1 fw-semibold small text-muted">Longitude</span>
                      <span className="d-block fw-bold text-dark">{building?.location?.lng?.toFixed(6) || '0.000000'}</span>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>

          <div style={{ marginTop: 'auto' }} className="px-4 py-2">
            <PrimaryButton
              className="w-100"
              label="Update Building"
              clicked={() => {
                setConfirmAlert(true);
              }}
            />
          </div>
        </div>
        <Spinner show={loading} />

        <ConfirmAlert
          message={`Do you confirm changes in the building?`}
          primaryText={'Yes'}
          secondaryText={'No'}
          secondaryAction={() => {
            setConfirmAlert(false);
          }}
          visible={confirmAlert}
          title={'Finish Building Editing'}
          primaryAction={() => {
            setConfirmAlert(false);
            updateBuilding();
          }}
          onClose={() => {
            setConfirmAlert(false);
          }}
        />

        <ConfirmAlert
          message={assetBuildingConfimrationModal.message}
          primaryText={'Yes'}
          secondaryText={'No'}
          secondaryAction={() => {
            props.cancelBoundaryDraw();
            setIsDrawActive(false);
            setAssetBuildingConfimrationModal({ alert: false, message: '' });
            setRemoveBuildingAssets(false);
          }}
          visible={assetBuildingConfimrationModal.alert}
          title={'Confirm Boundary Changes'}
          primaryAction={() => {
            setAssetBuildingConfimrationModal({ alert: false, message: '' });
            setRemoveBuildingAssets(true);
          }}
          onClose={() => {
            props.cancelBoundaryDraw();
            setIsDrawActive(false);
            setAssetBuildingConfimrationModal({ alert: false, message: '' });
            setRemoveBuildingAssets(false);
          }}
        />

        <ErrorAlert
          show={error.alert}
          onDismiss={() => {
            setError({ message: '', alert: false });
          }}
          message={error.message}
        />
        <SuccessAlert
          show={success.alert}
          onDismiss={() => {
            setSuccess({ message: '', alert: false });
          }}
          message={success.message}
        />
        <WarningAlert
          show={warning.alert}
          onDismiss={() => {
            setWarning({ message: '', alert: false });
          }}
          message={warning.message}
        />
      </div>
    </div>
  );
};
